import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './style.m.less';

LoadingBar.propTypes = {
    label: PropTypes.string,
    withLabel: PropTypes.bool,
    className: PropTypes.string,
};

export default function LoadingBar({ label = 'Loading…', withLabel = true, className }) {
    const containerClasses = classNames(styles.container, className);
    return (
        <div className={containerClasses}>
            <div className={styles.bar} />
            {withLabel && <small className={styles.label}>{label}</small>}
        </div>
    );
}
